import React from 'react';
import { getEmptyStateMessage } from '../config/helpMessages';
import '../styles/components/emptyState.css';

interface EmptyStateProps {
  /** ID of the empty state message from helpMessages.ts */
  messageId: string;
  /** Optional action button */
  action?: {
    label: string;
    onClick: () => void;
  };
}

/**
 * Empty state message shown when a filtered view has no items.
 * Content is pulled from centralized helpMessages.ts config.
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  messageId,
  action,
}) => {
  const emptyState = getEmptyStateMessage(messageId);

  if (!emptyState) {
    return null;
  }

  return (
    <div className="empty-state">
      {emptyState.icon && (
        <span className="empty-state-icon">{emptyState.icon}</span>
      )}
      <h3 className="empty-state-title">{emptyState.title}</h3>
      <p className="empty-state-message">{emptyState.message}</p>
      {action && (
        <button
          className="empty-state-action"
          onClick={action.onClick}
        >
          {action.label}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
